import React from 'react';

function Funcionalidades() {
  return (
    <section id="Funcionalidades" style={styles.container}>
      <h2 style={styles.title}>Minhas Funcionalidades</h2>
      <p style={styles.subtitle}>
        Explore algumas funcionalidades que criei para facilitar o seu dia a dia, desde a leitura de CEP até a criação de senhas seguras!
      </p>

      {/* Seção de Funcionalidades */}
      <div style={styles.featuresContainer}>
        {/* Funcionalidade 1: Leitura de CEP */}
        <div style={styles.featureCard}>
          <h3 style={styles.featureTitle}>Leitura de CEP</h3>
          <p style={styles.featureDescription}>
            Obtenha informações detalhadas sobre um CEP específico, como endereço, cidade e estado.
          </p>
          <a href="#cep" style={styles.link}>Ver Funcionalidade</a>
        </div>

        {/* Funcionalidade 2: Conversor de Texto */}
        <div style={styles.featureCard}>
          <h3 style={styles.featureTitle}>Conversor de Texto</h3>
          <p style={styles.featureDescription}>
            Converta texto entre diferentes formatos, como maiúsculas, minúsculas ou até mesmo códigos binários.
          </p>
          <a href="#conversor" style={styles.link}>Ver Funcionalidade</a>
        </div>

        {/* Funcionalidade 3: Qual meu IP */}
        <div style={styles.featureCard}>
          <h3 style={styles.featureTitle}>Qual meu IP</h3>
          <p style={styles.featureDescription}>
            Descubra o endereço IP atual da sua conexão de internet.
          </p>
          <a href="#ip" style={styles.link}>Ver Funcionalidade</a>
        </div>

        {/* Funcionalidade 4: Gerador de Senhas */}
        <div style={styles.featureCard}>
          <h3 style={styles.featureTitle}>Gerador de Senhas</h3>
          <p style={styles.featureDescription}>
            Crie senhas seguras de forma fácil e rápida para proteger suas contas.
          </p>
          <a href="#gerador-senha" style={styles.link}>Ver Funcionalidade</a>
        </div>

        {/* Funcionalidade 5: Gerador de CPF */}
        <div style={styles.featureCard}>
          <h3 style={styles.featureTitle}>Gerador de CPF</h3>
          <p style={styles.featureDescription}>
            Gere números de CPF válidos e verifique sua validade rapidamente.
          </p>
          <a href="#gerador-cpf" style={styles.link}>Ver Funcionalidade</a>
        </div>
      </div>
    </section>
  );
}

const styles = {
  container: {
    backgroundColor: "#f4f4f4",
    padding: "60px 20px",
    textAlign: "center",
  },
  title: {
    fontSize: "36px",
    color: "#333",
    marginBottom: "20px",
    fontWeight: "bold",
  },
  subtitle: {
    fontSize: "18px",
    color: "#555",
    marginBottom: "30px",
    lineHeight: "1.6",
    maxWidth: "800px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  featuresContainer: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "30px",
    marginTop: "40px",
  },
  featureCard: {
    backgroundColor: "#fff",
    padding: "25px",
    borderRadius: "8px",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    width: "280px",
    maxWidth: "100%",
    transition: "transform 0.3s",
    cursor: "pointer",
  },
  featureTitle: {
    fontSize: "22px",
    fontWeight: "bold",
    color: "#333",
    marginBottom: "10px",
  },
  featureDescription: {
    fontSize: "16px",
    color: "#666",
    marginBottom: "20px",
    textAlign: "justify",
  },
  link: {
    textDecoration: "none",
    color: "#3498db",
    fontSize: "15px",
    fontWeight: "bold",
    display: "inline-block",
    marginTop: "10px",
  },
};

export default Funcionalidades;
